import React from 'react'

import { B2CTypeTable } from '@/types.ts'
import { ToggleGroup } from '@/components'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { b2cActions } from '@/stores/slices/b2c-slice/b2c-slice.ts'
import { useAppDispatch } from '@/stores/hooks.ts'

export const B2CToggleButtons = (): React.ReactElement => {
  const { b2cType } = useB2CState()
  const dispatch = useAppDispatch()

  const handleTypeChange = (_: unknown, item: B2CTypeTable) => {
    dispatch(b2cActions.setFilter({ filterKey: 'b2cType', filterValue: item }))
  }
  return (
    <ToggleGroup<B2CTypeTable>
      items={[
        { title: 'По переводам', value: B2CTypeTable.PAYMENTS },
        { title: 'По реестрам', value: B2CTypeTable.REGISTRIES },
      ]}
      value={b2cType || B2CTypeTable.PAYMENTS}
      onChange={handleTypeChange}
    />
  )
}
